"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var style_1 = require("../../../style");
var SvgIcBlog = function () { return (react_1.default.createElement(style_1.SvgIcon, { height: '1em', viewBox: '0 0 24 24', width: '1em' },
    react_1.default.createElement("g", { className: 'SvgIcon__FillHoverColor', fill: '#777' },
        react_1.default.createElement("path", { d: 'M7.497 15a1.5 1.5 0 1 1 .006 3 1.5 1.5 0 0 1-.006-3zM14 18h-2.345A5.655 5.655 0 0 0 6 12.345V10a8 8 0 0 1 8 8z' }),
        react_1.default.createElement("path", { d: 'M15.6 18A9.604 9.604 0 0 0 6 8.4V6c6.627 0 12 5.373 12 12z' })))); };
exports.default = SvgIcBlog;
